import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Body3Light, Body4 } from '@/ui/typography';
import IconRequirements from '@/assets/icons/requirements.svg';
import { Modal } from 'antd';
import { Flex } from '@/ui/layout';
import Markdown from 'react-markdown';
import { Button } from '@/components/common/atoms';
import { useTranslation } from 'react-i18next';
import { kycApi } from '@/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const TextTooltip = ({
  isCTA,
  isReadTooltip = true,
  isVeriffQuestionnaire,
  questionSectionId,
  title,
  textArray,
  marginTop,
  marginBottom
}) => {
  const { t } = useTranslation();
  const { showErrorToast } = usePopups();
  const [active, setActive] = useState(!isReadTooltip && !isVeriffQuestionnaire);

  const openModal = () => {
    setActive(true);
  };

  const closeModal = () => {
    setActive(false);
  };

  const readTheInfo = async () => {
    try {
      const result = await kycApi.readSumSubTooltip({ questionSectionId });

      if (result) {
        await queryClient.refetchQueries({ queryKey: ['getSumSubStatus'] });
        closeModal();
      }
    } catch (e) {
      console.error(e);
      showErrorToast(e, true);
    }
  };

  const formattedText = useMemo(() => {
    let finalText = '';
    textArray.map((text) => {
      finalText += text.text + '\n\n';
    });
    return finalText;
  }, [textArray]);

  return (
    <>
      {isCTA ? (
        <Button type='primary' danger onClick={() => openModal()} text={t(title)} />
      ) : (
        <Box onClick={() => openModal()} $marginTop={marginTop} $marginBottom={marginBottom}>
          <Icon src={IconRequirements} />
          <Body4>{t(title)}</Body4>
        </Box>
      )}
      <Modal
        open={active}
        onCancel={closeModal}
        title={t(title)}
        footer={
          !isReadTooltip ? (
            <Button
              type='primary'
              onClick={() => readTheInfo()}
              text={t('I have read the information')}
            />
          ) : null
        }
      >
        <Flex gap={10} $marginTop={20}>
          <div className='markdown'>
            <Body3Light>
              <Markdown>{formattedText}</Markdown>
            </Body3Light>
          </div>
        </Flex>
      </Modal>
    </>
  );
};

const Box = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin-top: ${(p) => (p.$marginTop ? `${p.$marginTop}px` : '0')};
  margin-bottom: ${(p) => (p.$marginBottom ? `${p.$marginBottom}px` : '0')};

  &:hover {
    opacity: 0.8;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;
